import { render } from "./ToolsScreen.vue?vue&type=template&id=2d4fa332&scoped=true"
import script from "./ToolsScreen.vue?vue&type=script&lang=js"
export * from "./ToolsScreen.vue?vue&type=script&lang=js"

import "./ToolsScreen.vue?vue&type=style&index=0&id=2d4fa332&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d4fa332"]])

export default __exports__